/* eslint-disable */
import { EventBus } from '@/event-bus';
import { generic_storage } from '../_utilities/generic_storage';
import { invitationsService } from '../_services';

const extendedStore = generic_storage('invitationService');

extendedStore.state = {
  ...extendedStore.state,
  activityEvents: [],
}

extendedStore.actions = {
  ...extendedStore.actions,
  fetchAppointmentInvitations({ commit }, args = null) {
    commit('setIsLoading', true);
    return invitationsService.getAppointmentInvitations(args).then((response) => {
      commit('updateItems', response.data.results);
    }).catch(() => {
      EventBus.$emit('There has been an error while trying to fetch invites data, please try again in a few secons.');
    }).finally(() => {
      commit('setIsLoading', false);
    });
  },
  addAppointmentInvitationsActivity({ commit }, kwargs = {}) {
    commit('setIsLoading', true);
    return invitationsService.getAppointmentInvitationsActivity(kwargs).then((response) => {
      commit('addItemPage', response.data.results);
      commit('updateItemsCount', response.data.count);
    }).catch(() => {
      EventBus.$emit('There has been an error while trying to fetch invites data, please try again in a few secons.');
    }).finally(() => {
      commit('setIsLoading', false);
    });
  },
  fetchActivityEvents({ commit }, id) {
    commit('setIsLoading', true);
    return invitationsService.getActivityEvents(id).then(response => {
      commit('updateActivityEvents', response.data.results)
    }).finally(() => {
      commit('setIsLoading', false)
    })
  }
};

extendedStore.mutations = {
  ...extendedStore.mutations,
  updateActivityEvents(state, events) {
    state.activityEvents = events
  },
}

export const invitations = extendedStore;
export default invitations;
